import { useTranslation } from 'react-i18next'
import React from 'react'
import { SummaryCell } from './SummaryCell'

export function FinancialCell ({ label, amount, symbol = '' }) {
  const { t } = useTranslation()
  const topContent = t(label)
  const bottomContent = amount.toFixed(2) + symbol
  return <SummaryCell topContent={topContent} bottomContent={bottomContent}/>
}
